import PageTitle from './PageTitle';
import PageTitleProvider from './PageTitleProvider';

export { PageTitle, PageTitleProvider };
